import UsersIndex from "@/views/users/UsersIndex.vue";
import UserCreate from "@/views/users/UserCreate.vue";
import UserEdit from "@/views/users/UserEdit.vue";
// 
export default [
    {
        path: '/users',
        name: 'users.index',
        component: UsersIndex,
        meta: {
            title: 'Users Management',
            requiresAuth: true,
            roles: ['sponsor','vendor']
        }
    },
    {
        path: '/users/create',
        name: 'users.create',
        component: UserCreate,
        meta: {
            title: 'Create User',
            requiresAuth: true,
            roles: ['sponsor','vendor']
        }
    },
    {
        path: '/users/:id/edit',
        name: 'users.edit',
        component: UserEdit,
        meta: {
            title: 'Edit User',
            requiresAuth: true,
            roles: ['sponsor','vendor']
        }
    }
]
